export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'topic',
    sortable: false,
    label: 'field.topic',
    class: 'break-spaces',
  },
  {
    key: 'conversation',
    sortable: false,
    label: 'field.conversation',
  },
  {
    key: 'freqCount',
    sortable: false,
    label: 'field.askedCount',
  },
  {
    key: 'time',
    sortable: false,
    sortField: 'time',
    label: 'field.time',
  },
  {
    key: 'createdAt',
    sortable: false,
    sortField: 'createdAt',
    label: 'label.pushedAt',
  },

  // {
  //   key: "count",
  //   sortable: false,
  //   label: "field.count",
  // },
  {
    key: 'actions',
    label: 'general.action',
  },
]
